var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-skill-viewer" },
    [
      _c(
        "yxt-radio-group",
        {
          staticClass: "mb24 float__right",
          attrs: { type: "tab-radio", size: "small" },
          model: {
            value: _vm.type,
            callback: function ($$v) {
              _vm.type = $$v
            },
            expression: "type",
          },
        },
        [
          _c("yxt-radio-button", { attrs: { label: "radar" } }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("pc_gwnl_web_radarShow")) + "\n    "
            ),
          ]),
          _c("yxt-radio-button", { attrs: { label: "table" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_gwnl_training_listShow")) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex width100" },
        [
          _vm.type === "radar"
            ? _vm._l(_vm.skills, function (data) {
                return _c(
                  "div",
                  {
                    key: data.id,
                    staticClass: "flex-column-center",
                    style: {
                      width:
                        (_vm.skills.length ? 100 / _vm.skills.length : 100) +
                        "%",
                    },
                  },
                  [
                    _vm.slotRador
                      ? [
                          _vm._t("radar", null, {
                            data: data[_vm.classifyProps],
                          }),
                        ]
                      : _c("yxtbiz-polestar-radar", {
                          staticClass: "width100",
                          attrs: {
                            datas: data[_vm.classifyProps],
                            fields: _vm.legends,
                            "fields-map": _vm.fieldsMap,
                            "child-key": _vm.childKey,
                            options: _vm.options,
                            checkbox: _vm.checkbox,
                            "checkbox-style": { marginTop: "24px" },
                            "checkbox-color-type": "marker",
                            "label-style": _vm.labelStyle,
                            radius: _vm.radius,
                            axis: _vm.axis,
                            label: _vm.label,
                            "virtual-line": !_vm.showSkillLevel,
                            "value-map": _vm.enableExcellentLevel
                              ? _vm.excellentShowLevelName
                              : _vm.showLevelName,
                          },
                          on: { labelClick: _vm.handleLabelClick },
                        }),
                    _c(
                      "div",
                      {
                        key: data.id,
                        staticClass:
                          "text-center font-size14 lh22 color-gray-10 mt24 font-weight-500",
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(data.name) + "\n        "
                        ),
                      ]
                    ),
                  ],
                  2
                )
              })
            : _vm._e(),
          _vm.type === "table"
            ? [
                _vm.slotTable
                  ? [_vm._t("table")]
                  : _c("skill-tables", {
                      staticClass: "flex-column-center flex-grow",
                      attrs: {
                        "skill-catalogs": _vm.skills,
                        "enable-weight-switch": _vm.enableWeightSwitch,
                        "enable-excellent-level": _vm.enableExcellentLevel,
                        "is-show-skill-level": !!_vm.showSkillLevel,
                        "classify-props": _vm.classifyProps,
                        "child-key": _vm.childKey,
                      },
                    }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }